import React, { useEffect, useState } from 'react';
import ListTableView from './ListTableView';
import { useDispatch, useSelector } from 'react-redux';
import { getMovieList, setFilterType } from '../../../../redux/actions/Movies';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import useStyles from '../index.style';
import PerfectScrollbar from 'react-perfect-scrollbar';
import EmptyResult from './EmptyResult';
import { Pagination } from '@material-ui/lab';

const MovieList = () => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);

  const { movieList, filterType, metaMovieList } = useSelector(({ movies }) => movies);

  useEffect(() => {
    dispatch(setFilterType({ ...filterType, page }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  useEffect(() => {
    dispatch(getMovieList(filterType));
  }, [filterType, dispatch]);

  const handlePage = (event, value) => {
    setPage(value);
  };

  const classes = useStyles({
    height: 340,
  });
  return movieList.length > 0 ? (
    <Box className={classes.inBuildAppMainContent}>
      <PerfectScrollbar className={classes.perfectScrollbarContactCon}>
        <ListTableView />
      </PerfectScrollbar>
      <Pagination
        className={classes.paginationRoot}
        count={metaMovieList.total_pages}
        page={page}
        onChange={handlePage}
        color="primary"
      />
    </Box>
  ) : (
    <Box className={classes.inBuildAppMainContent}>
      <EmptyResult />
    </Box>
  );
};

export default MovieList;

MovieList.prototype = {
  onShowContactDetail: PropTypes.func,
};
